import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [IconButtonComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  exports: [IconButtonComponent]
})
export class IconButtonModule {}
